import React from 'react'
import { Box, Heading, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo)
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return <ErrorMessage />
    }

    return this.props.children
  }
}

const ErrorMessage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box textAlign="center" py={10}>
      <Heading as="h1" size="xl" mb={6}>
        {t('error.title')}
      </Heading>
      <Text fontSize="lg">{t('error.description')}</Text>
    </Box>
  )
}

export default ErrorBoundary
